import React from 'react';
import { Trigger as MenuActionRoot } from '@radix-ui/react-dropdown-menu';
import { node } from 'prop-types';

var MenuAction = function MenuAction(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(MenuActionRoot, {
    asChild: true
  }, children);
};

MenuAction.propTypes = {
  children: node.isRequired
};
MenuAction.displayName = 'Menu.Action';
export default MenuAction;